export function isProgressChangedError(error) {
  return error?.status === 409 && (
    error?.detail?.code === 'mini_task_progress_changed'
    // Support the previous backend during the coordinated rollout.
    || error?.detail === 'Görev sırası değişti.'
  );
}
